module.exports = __webpack_public_path__ + "img/Social_8.cc20f929.webp";